import React from 'react';
import { AlertStyle, RowDiv, ColDiv } from 'styles/Common';
import { Text } from 'styles';
import { Button } from 'components';
import { Dim } from './Dim';

export function Confirm({ content, cancel, confirm, title, ...props }) {
  return (
    <Dim>
      <AlertStyle>
        {title && (
          <Text $fontSize={20} $fontWeight={700} {...props}>
            {title}
          </Text>
        )}
        <RowDiv $margin="24px 0">{content}</RowDiv>
        <RowDiv $gap={8}>
          <Button label="닫기" btnType="small" btnStyle="cancel" onClick={cancel.onClick} />
          <Button label="확인" btnType="small" btnStyle="fill" onClick={confirm.onClick} />
        </RowDiv>
      </AlertStyle>
    </Dim>
  );
}
